module.exports = __webpack_public_path__ + "static/img/player_06_program.98f735d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_06_program.svg
// module id = /ugY
// module chunks = 0